import React from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';

import * as LoyaltyProgramService from '../../../../../../api/services/loyaltyProgramService';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { SubmitButton } from '../../../../../../components/Form';
import { TextField } from '../../../../../../components/FormikAdapter';
import { FormRow } from '../../../../../../components/FormLayout';

//------------------------------------------------------------------------------
// Types
//------------------------------------------------------------------------------

type Props = Pick<DialogProps, 'open' | 'onExit'> & {
  merchantId: string;
  rateLimit: number;
  onClose: () => void;
};

interface EditRateLimitFormValues {
  timeLimit: number;
}

//------------------------------------------------------------------------------
// Validation
//------------------------------------------------------------------------------

const ValidationSchema = Yup.object().shape({
  timeLimit: Yup.number()
    .required('Required')
    .min(0, 'Must be positive number'),
});

//------------------------------------------------------------------------------
// Component
//------------------------------------------------------------------------------

export default function EditRateLimitDialog({
  merchantId,
  rateLimit,
  open,
  onExit,
  onClose,
}: Props) {
  const initialValues = {
    timeLimit: rateLimit,
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={async (values, actions) => {
        const { timeLimit } = values;
        try {
          await LoyaltyProgramService.updateStampRateLimit(
            merchantId,
            timeLimit
          );

          actions.setSubmitting(false);
          actions.resetForm();
          onClose();
        } catch {
          actions.setSubmitting(false);
          alert('There was an error submitting this form');
        }
      }}
    >
      {({ isSubmitting, resetForm }) => (
        <Dialog open={open} onClose={onClose} onExit={onExit}>
          <Form translate="no" noValidate>
            <DialogTitle>Edit Contactless Rate Limit</DialogTitle>

            <DialogContent>
              <FormRow>
                <Field
                  component={TextField}
                  name="timeLimit"
                  label="Rate Limit"
                  autoFocus
                  fullWidth
                  required
                />
              </FormRow>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  resetForm();
                  onClose();
                }}
                color="primary"
              >
                Cancel
              </Button>
              <SubmitButton
                type="submit"
                size="small"
                isSubmitting={isSubmitting}
              >
                Update Rate Limit
              </SubmitButton>
            </DialogActions>
          </Form>
        </Dialog>
      )}
    </Formik>
  );
}
